var map = {
	"./a7a5_tron.svg": 4746,
	"./amd.svg": 604,
	"./aud.svg": 4452,
	"./azn.svg": 5275,
	"./bgn.svg": 9103,
	"./bnb.svg": 2612,
	"./bob.svg": 1267,
	"./brl.svg": 6806,
	"./btc.svg": 1155,
	"./byn.svg": 3529,
	"./cad.svg": 1038,
	"./chf.svg": 5627,
	"./col.svg": 7676,
	"./cop_bank.svg": 677,
	"./cop_fiat.svg": 9375,
	"./dai_bnb.svg": 4871,
	"./dai_eth.svg": 5208,
	"./default.svg": 9969,
	"./eth.svg": 5135,
	"./eth_arb.svg": 2999,
	"./eur.svg": 553,
	"./eur_card.svg": 1731,
	"./eurc.svg": 6809,
	"./eurc_ethereum.svg": 6023,
	"./gbp.svg": 7947,
	"./gbp_card.svg": 8256,
	"./hkd.svg": 9335,
	"./idr.svg": 3185,
	"./ils.svg": 184,
	"./inr.svg": 5699,
	"./jpy.svg": 7253,
	"./kgs.svg": 5547,
	"./kpw.svg": 730,
	"./krw.svg": 48,
	"./kzt.svg": 3307,
	"./ltc.svg": 1101,
	"./mdl.svg": 8891,
	"./mxn.svg": 8165,
	"./nok.svg": 9278,
	"./pen_bank.svg": 4708,
	"./php.svg": 5134,
	"./pln.svg": 6196,
	"./pol.svg": 4595,
	"./ron.svg": 7847,
	"./rsd.svg": 2081,
	"./rub.svg": 5777,
	"./sek.svg": 7973,
	"./sgd.svg": 1052,
	"./thb.svg": 5344,
	"./tjs.svg": 6055,
	"./tmt.svg": 6565,
	"./ton.svg": 8933,
	"./trx.svg": 4948,
	"./try.svg": 6229,
	"./uah.svg": 5528,
	"./usd_bank.svg": 8203,
	"./usd_card.svg": 9991,
	"./usd_fiat.svg": 6237,
	"./usdc_arbitrum.svg": 7446,
	"./usdc_eth.svg": 8345,
	"./usdc_polygon.svg": 5314,
	"./usdt_arbitrum.svg": 2507,
	"./usdt_bsc.svg": 6283,
	"./usdt_eth.svg": 7698,
	"./usdt_polygon.svg": 4185,
	"./usdt_ton.svg": 9928,
	"./usdt_trx.svg": 2317,
	"./uzs.svg": 2242,
	"./vnd.svg": 5550,
	"./zar.svg": 7117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7744;